import axios from 'axios';

const normalizeApiBaseUrl = () => {
  const rawBaseUrl = process.env.REACT_APP_API_URL || '';
  const trimmedBaseUrl = rawBaseUrl.trim().replace(/\/+$/, '');

  if (!trimmedBaseUrl) return '/api';
  return trimmedBaseUrl.endsWith('/api')
    ? trimmedBaseUrl
    : `${trimmedBaseUrl}/api`;
};

const okamApi = axios.create({
  baseURL: normalizeApiBaseUrl(),
  timeout: 8000
});

const resolveMediaUrl = (mediaUrl) => {
  if (!mediaUrl || /^https?:\/\//i.test(mediaUrl)) return mediaUrl;

  const apiBaseUrl = normalizeApiBaseUrl();
  const apiOrigin = /^https?:\/\//i.test(apiBaseUrl)
    ? new URL(apiBaseUrl).origin
    : window.location.origin;

  return new URL(mediaUrl, apiOrigin).toString();
};

const prepareHlsUrl = (mediaUrl) => {
  const resolvedUrl = resolveMediaUrl(mediaUrl);
  if (!resolvedUrl) return resolvedUrl;

  const url = new URL(resolvedUrl, window.location.origin);
  if (!url.searchParams.has('cookieCheck')) {
    // Native mobile HLS players can fail on MediaMTX's cookie-check redirect.
    url.searchParams.set('cookieCheck', '1');
  }

  return url.toString();
};

const getPublicCameraName = (name) => {
  const cameraName = (name || '').trim();
  if (!cameraName) return 'Aile Köyü';

  return cameraName.replace(/Çocuk Oyun Köyü/giu, 'Aile Köyü');
};

const withResolvedMediaUrls = (camera) => ({
  ...camera,
  name: getPublicCameraName(camera?.name),
  hlsUrl: prepareHlsUrl(camera?.hlsUrl),
  webRtcUrl: resolveMediaUrl(camera?.webRtcUrl)
});

export const getOkamCameras = async () => {
  const response = await okamApi.get('/okam/cameras');

  return {
    enabled: response.data?.enabled === true,
    cameras: Array.isArray(response.data?.cameras)
      ? response.data.cameras.map(withResolvedMediaUrls)
      : []
  };
};

export const getOkamPlayback = async (cameraId) => {
  const response = await okamApi.get(
    `/okam/cameras/${encodeURIComponent(cameraId)}/playback`,
    { timeout: 20000 }
  );

  return withResolvedMediaUrls(response.data || {});
};

export const getOkamStatus = async (cameraId) => {
  const response = await okamApi.get(
    `/okam/cameras/${encodeURIComponent(cameraId)}/status`
  );

  return withResolvedMediaUrls(response.data || {});
};
